// src/config/firebase-dev-config.js

// 개발/테스트넷 환경(painori-spotnori)을 위한 Firebase 설정
export const devFirebaseConfig = {
  apiKey: "AIzaSyA1gW4fUM49mxs96P2o4WvFtXBxYVkzQ2A",
  authDomain: "painori-spotnori.firebaseapp.com",
  projectId: "painori-spotnori",
  storageBucket: "painori-spotnori.firebasestorage.app", // 'firebasestorage.app'이 올바른 주소입니다.
  messagingSenderId: "1051550015590",
  appId: "1:1051550015590:web:568b605ba175de05d68da7",
  // measurementId 제거됨 - Google Analytics 사용 안함
};
